// UTILITIES
async function addSingleProductToCart(variantId, productId, qty = 1, properties = {}) {
  if (!variantId) return null;
  if (!productId) return null;

  let formData = {
    'items': [{
      'id': variantId,
      'quantity': qty,
      properties: properties
    }]
  };

  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(async response => {
    const data = await response.json()

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent(
        'cart:update', {
          detail: {
            source: 'cart-upsell-component',
            itemCount: qty,
            productId: productId,
            data: {
              sections: null
            }
          }
        }
      ));
    }, 100);

    return data;
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

window.addEventListener('DOMContentLoaded', () => {
    // TABBED COLLECTIONS
    const tabbedCollectionBtns = document.querySelectorAll('.tabbed-collections__tab-btn');
    if (tabbedCollectionBtns.length) {
        tabbedCollectionBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                if (btn.classList.contains('active')) return;

                const targetId = btn.getAttribute('data-id');
                if (!targetId) return;

                const parent = btn.closest('.tabbed-collections__collections');
                if (!parent) return;

                const allBtns = parent.querySelectorAll('.tabbed-collections__tab-btn');
                if (!allBtns) return;

                const allTabs = parent.querySelectorAll('.tabbed-collections__collection-tab');
                if (!allTabs) return;

                 allBtns.forEach(btn2 => {
                    btn2.classList.remove('active');
                })
                btn.classList.add('active');

                allTabs.forEach(tab => {
                    tab.classList.remove('active');
                })
                allTabs.forEach(tab => {
                    if (tab.getAttribute('data-id') == targetId) {
                        tab.classList.add('active');
                    }
                })
            })
        })
    }

    // FEATURE ICONS
    class IconFeaturesCarousel extends HTMLElement {
      constructor() {
        super();
        this.currentSlide = 0;
        this.totalSlides = 3;
        this.isDragging = false;
        this.startX = 0;
        this.currentX = 0;
        this.dragOffset = 0;
        this.blockId = this.getAttribute('data-block-id');
      }

      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dots = this.querySelectorAll(`.icon-features__dot-${this.blockId}`);
        
        this.setupEventListeners();
        this.updateCarousel();
      }

      setupEventListeners() {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.goToSlide(index);
          });
        });

        this.track.addEventListener('mousedown', this.handleDragStart.bind(this));
        this.track.addEventListener('mousemove', this.handleDragMove.bind(this));
        this.track.addEventListener('mouseup', this.handleDragEnd.bind(this));
        this.track.addEventListener('mouseleave', this.handleDragEnd.bind(this));

        this.track.addEventListener('touchstart', this.handleDragStart.bind(this));
        this.track.addEventListener('touchmove', this.handleDragMove.bind(this));
        this.track.addEventListener('touchend', this.handleDragEnd.bind(this));

        this.track.addEventListener('dragstart', (e) => e.preventDefault());
      }

      handleDragStart(e) {
        this.isDragging = true;
        this.startX = this.getEventX(e);
        this.currentX = this.startX;
        this.track.style.transition = 'none';
        this.track.style.cursor = 'grabbing';
      }

      handleDragMove(e) {
        if (!this.isDragging) return;
        
        e.preventDefault();
        this.currentX = this.getEventX(e);
        this.dragOffset = this.currentX - this.startX;
        
        const baseTranslateX = -this.currentSlide * 33.333;
        const dragTranslateX = (this.dragOffset / this.track.offsetWidth) * 33.333;
        const newTranslateX = baseTranslateX + dragTranslateX;
        
        this.track.style.transform = `translateX(${newTranslateX}%)`;
      }

      handleDragEnd(e) {
        if (!this.isDragging) return;
        
        this.isDragging = false;
        this.track.style.transition = 'transform 0.3s ease';
        this.track.style.cursor = 'grab';
        
        const threshold = this.track.offsetWidth * 0.1;
        
        if (Math.abs(this.dragOffset) > threshold) {
          if (this.dragOffset > 0 && this.currentSlide > 0) {
            this.goToSlide(this.currentSlide - 1);
          } else if (this.dragOffset < 0 && this.currentSlide < this.totalSlides - 1) {
            this.goToSlide(this.currentSlide + 1);
          } else {
            this.updateCarousel();
          }
        } else {
          this.updateCarousel();
        }
        
        this.dragOffset = 0;
      }

      getEventX(e) {
        return e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      }

      goToSlide(slideIndex) {
        this.currentSlide = Math.max(0, Math.min(slideIndex, this.totalSlides - 1));
        this.updateCarousel();
      }

      updateCarousel() {
        const translateX = -this.currentSlide * 33.333;
        this.track.style.transform = `translateX(${translateX}%)`;
        
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === this.currentSlide);
        });
      }
    }
    customElements.define('icon-features-carousel', IconFeaturesCarousel);

    // CART UPSELL
    const cartUpsellATCBtns = document.querySelectorAll(".cart-upsell__atc");
    cartUpsellATCBtns.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        if (btn.hasAttribute('disabled')) return;
        if (!btn.hasAttribute('data-variant-id')) return;
        if (!btn.hasAttribute('data-product-id')) return;

        btn.setAttribute('disabled', 'disabled')
        let btnContent = btn.innerHTML;
        btn.innerHTML = `<span class="spinner"></span>`;

        const variantId = btn.getAttribute('data-variant-id');
        const productId = btn.getAttribute('data-product-id');

        await addSingleProductToCart(variantId, productId, 1, {});

        btn.removeAttribute('disabled');
        btn.innerHTML = btnContent;
      })
    })

    // READ MORE
    const readMoreBtns = document.querySelectorAll('.read-more-btn');
    readMoreBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const truncated = btn.closest('.read-more--truncated');
        console.log({parent})
        if (!parent) return;

        const full = truncated?.nextElementSibling;
        console.log({full})
        if (!full) return;

        truncated.classList.add('hidden');
        full.classList.remove('hidden');
      })
    })

})